import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, booleanFormatter } from '../../../../components/tables/table'
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog'
import { getAttributes, updateAttribute, syncAttributes } from '../../../../../api/attribute'
import { Button, Tooltip } from '@material-ui/core'
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import VisibilityIcon from '@material-ui/icons/Visibility'
import { alertError, alertSuccess, alertLoading } from '../../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(attributes) {
  let data = []
  for (let i = 0; i < attributes.length; ++i) {
      const elem = {}
      elem.name = attributes[i].name
      elem.active = attributes[i].active
      elem.id = attributes[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function AttributesPage() {
  const [data, setData] = useState([])
  const [attribute, setAttribute] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    const elem = data.find(item => item.id === cell)
    return (<>
      <Tooltip title="View">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/product-view-attribute/' + cell)}>
          <VisibilityIcon/>
        </Button>
      </Tooltip>
      <Tooltip title={elem?.active ? "Disable" : "Enable"}>
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setAttribute(elem)
            setOpenConfirmDialog(true)
          }}>
          {elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon/>}
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'name', text: 'Name', sort: true },
    { dataField: 'active', text: 'Active', align: 'center', headerAlign: 'center', formatter: booleanFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getAttributes().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get attributes.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Attributes list'>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                alertLoading({ title: 'Getting all attributes...'})
                syncAttributes().then(res => {
                  if (res.status === 200) {
                    alertSuccess({ title: 'Done!', customMessage: 'All attributes have been imported successfully.' })
                    setRefresh(true)
                  }
                }).catch(error => {
                  alertError({ error: error, customMessage: 'Could not sync attributes.' })
                })
              }}
            >
              Sync attributes
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${attribute?.active ? 'disable' : 'enable'} this attribute?`}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              updateAttribute(attribute.id, !attribute.active).then(res => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({ title: `${attribute.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Attribute ${attribute.active ? 'disabled' : 'enabled'} successfully` })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: `Could not ${attribute.active ? 'disable' : 'enable'} attribute.` })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
